export const create = {
  createSuccessfully: '新しいタンク履歴を正常に作成しました！',
}
